// ============================================================
// WHY CHOOSE US — editable content used on Home and About.
// ============================================================

export const WHY_CHOOSE_US = [
  {
    icon: "heartHandshake",
    title: "Compassionate Patient Care",
    description: "Every patient is treated with warmth, patience and respect — never as a case number.",
  },
  {
    icon: "graduationCap",
    title: "Qualified Healthcare Professionals",
    description: "Consultations are handled by qualified doctors who explain your condition clearly.",
  },
  {
    icon: "calendarCheck",
    title: "Convenient Appointment Scheduling",
    description: "Request an appointment on WhatsApp in under a minute — no queues, no paperwork.",
  },
  {
    icon: "building",
    title: "Modern Clinical Environment",
    description: "A clean, well-maintained clinical setting designed around patient safety and comfort.",
  },
  {
    icon: "messagesSquare",
    title: "Clear Communication",
    description: "We explain findings, options and costs in simple language so you can decide confidently.",
  },
  {
    icon: "armchair",
    title: "Focus on Patient Comfort",
    description: "From the waiting area to the consultation room, your comfort guides how we work.",
  },
];
